import {useMemo, useEffect} from 'react';
import debounce from 'lodash.debounce';

type RefineFn = (value: string) => void;

export function useDebouncedRefine(refine: RefineFn, delay = 300) {
  const debounced = useMemo(() => debounce(refine, delay), [refine, delay]);

  useEffect(() => {
    return () => debounced.cancel(); // prevent setState after unmount
  }, [debounced]);

  return debounced;
}
